// mui
import { Grid, Skeleton, Box, Typography } from '@mui/material';

// ui components
import { CasualCard, StackedBarChartCard } from 'ui-component';

import useCard from 'hooks/useCard';
import { useTranslation } from 'react-i18next';
import Search from 'views/dashboard/Search';

const StatisticsSkeleton = () => (
    <Grid container spacing={2} sx={{ p: 2 }}>
        <Grid item xs={12} md={4}>
            <Skeleton variant="rectangular" height={320} />
        </Grid>

        <Grid item xs={12} md={8}>
            <Skeleton variant="rectangular" height={320} />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
            <Skeleton variant="rectangular" height={320} />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
            <Skeleton variant="rectangular" height={320} />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
            <Skeleton variant="rectangular" height={320} />
        </Grid>
    </Grid>
);

const Statistics = () => {
    const { t } = useTranslation();

    const { status, statistics, handleClick, palette, paletteForPie, chartInitialized, dashboardQuery, log } = useCard();

    const pieCharts = [
        { value: 'HealthCertifications', label: 'Δελτία Υγείας' },
        { value: 'Renewals', label: 'Ανανεώσεις' },
        { value: 'CardStock', label: 'Έξυπνες Κάρτες' }
    ];

    const expirationStats = status === 'success' && statistics && statistics[1] !== null ? statistics[1] : null;

    return {
        loading: <StatisticsSkeleton />,
        success: (
            <Grid container spacing={2} sx={{ p: 2 }}>
                {/* Γενική αναζήτηση */}
                <Grid item xs={12}>
                    <Typography variant="h4" sx={{ mb: 2 }}>
                        {t('GeneralSearch')}
                    </Typography>
                    <Search />
                </Grid>
                {/* Εγγραφές Μητρώου */}
                <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
                    <CasualCard props={statistics && statistics[0] !== null ? statistics[0] : null} handleClick={handleClick} />
                </Grid>

                {/* Αιτήσεις */}
                <Grid item xs={12} md={8} sx={{ display: 'flex' }}>
                    <StackedBarChartCard
                        props={statistics && statistics[3] !== null ? statistics[3] : null}
                        palette={palette}
                        dashboardQuery={dashboardQuery}
                        log={log}
                        chartInitialized={chartInitialized}
                        typeOfChart="bar"
                    />
                </Grid>

                {/* Multiple Pie Charts */}
                {/* <Grid item xs={12}>
                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            borderRadius: 2,
                            p: 2,
                            boxShadow: 1
                        }}
                    >
                        <Typography variant="h4" sx={{ mb: 2 }}>
                            {t('Expirations')}
                        </Typography>

                        <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
                            {pieCharts.map((pie) => (
                                <Grid key={pie.value} item xs={12} sm={6} lg={3}>
                                    <StackedBarChartCard
                                        props={expirationStats}
                                        palette={paletteForPie}
                                        dashboardQuery={dashboardQuery}
                                        log={log}
                                        typeOfChart="pie"
                                        pieOption={pie.value}
                                        title={pie.label}
                                        hideHeader
                                        compact
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Grid> */}
            </Grid>
        ),
        error: <div>Error</div>
    }[status];
};

export default Statistics;
